const notionCard = {
  notionTitle: "GEEQUIP Knowledge Center on Notion!",
  notionDescription: "Access Notion and see all tutorials available for you!",
  notionLink: "Access Tutorials",
}

export default notionCard;